import React from 'react';
import { BsEye, BsEyeSlash } from 'react-icons/bs';
import Unidade from '../../../model/Unidade';

interface FiltrosProcessosProps {
  filtros: {
    editalNome: string;
    identificador: string;
    responsavel: string;
    unidadeId: string;
    status: 'ATIVOS' | 'CANCELADOS' | 'FINALIZADOS' | '';
  };
  unidades: Unidade[];
  onFiltroChange: (campo: string, valor: string) => void;
  visualizacaoDetalhada: boolean;
  onToggleVisualizacao: () => void;
}

const FiltrosProcessos: React.FC<FiltrosProcessosProps> = ({ filtros, unidades, onFiltroChange, visualizacaoDetalhada, onToggleVisualizacao }) => {
  return (
    <div className="filtros-container" style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
      <div className="filtros-grid" style={{ flex: 1 }}>
        <div className="form-group">
          <label>Edital</label>
          <input 
            type="text" 
            className="form-control" 
            value={filtros.editalNome} 
            onChange={(e) => onFiltroChange('editalNome', e.target.value)} 
            placeholder="Digite o nome do edital" 
          />
        </div>
        <div className="form-group">
          <label>Identificador</label>
          <input 
            type="text" 
            className="form-control" 
            value={filtros.identificador} 
            onChange={(e) => onFiltroChange('identificador', e.target.value)} 
            placeholder="Digite o identificador" 
          />
        </div>
        <div className="form-group">
          <label>Responsável</label>
          <input 
            type="text" 
            className="form-control" 
            value={filtros.responsavel} 
            onChange={(e) => onFiltroChange('responsavel', e.target.value)} 
            placeholder="Digite o nome do responsável" 
          />
        </div>
        <div className="form-group">
          <label>Unidade</label>
          <select 
            className="form-control" 
            value={filtros.unidadeId} 
            onChange={(e) => onFiltroChange('unidadeId', e.target.value)}
          >
            <option value="">Todas as unidades</option>
            {unidades.map(unidade => 
              <option key={unidade.id} value={unidade.id}>{unidade.nome}</option>
            )}
          </select>
        </div>
        <div className="form-group">
          <label>Status</label>
          <select 
            className="form-control" 
            value={filtros.status} 
            onChange={(e) => onFiltroChange('status', e.target.value)}
          >
            <option value="ATIVOS">Ativos</option>
            <option value="CANCELADOS">Cancelados</option>
            <option value="FINALIZADOS">Finalizados</option>
          </select>
        </div>
      </div>
      <button
        onClick={onToggleVisualizacao}
        style={{
          backgroundColor: 'transparent',
          border: '1px solid #ddd',
          borderRadius: '4px',
          padding: '8px 12px',
          fontSize: '13px',
          color: '#666',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          height: '38px',
          flexShrink: 0
        }}
        title={visualizacaoDetalhada ? 'Ocultar detalhes' : 'Mostrar detalhes'}
      >
        {visualizacaoDetalhada ? <BsEyeSlash size={14} /> : <BsEye size={14} />}
      </button>
    </div>
  );
};

export default FiltrosProcessos;